export enum TestStatus {
  Draft = 'draft',
  Published = 'published',
  Unpublished = 'unpublished',
}
